import {ChangeDetectorRef, EmbeddedViewRef, TemplateRef, ViewContainerRef} from '@angular/core';
import {Observable, takeUntil} from 'rxjs';
import {Scrollbar} from '../../custom-scrollbar/scrollbar';
import {EmptyRowTemplateContext} from '../empty-row-template-context';

export class TableEmptyRows {

    public rows: any[];

    public set emptyRow(value: any) {
        this.emptyRowTemplateContext.$implicit = value;
    }

    private readonly emptyRowViewRefs: Array<EmbeddedViewRef<EmptyRowTemplateContext>> = [];

    private readonly emptyRowTemplateContext: EmptyRowTemplateContext = {
        $implicit: {},
        empty: true
    };

    private rowCount: number = 0;
    private minRowCount: number = 0;

    constructor(
        private viewContainerRef: ViewContainerRef,
        private templateRef: TemplateRef<EmptyRowTemplateContext>,
        private availableRowCount$: Observable<number>,
        private changeDetectorRef: ChangeDetectorRef,
        private destroy$: Observable<any>,
        private scrollbar?: Scrollbar
    ) {
        this.listenToAvailableRowCount();
    }

    public checkForUpdates(): void {
        const newRowCount = this.rows?.length ?? 0;

        if (newRowCount !== this.rowCount) {
            this.rowCount = newRowCount;
            this.update();
        }
    }

    private update(): void {
        const emptyRowCount: number = this.minRowCount <= this.rowCount ? 0 : this.minRowCount - this.rowCount;

        if (this.scrollbar) {
            this.scrollbar.isEnabled = !emptyRowCount;
        }

        this.produceEmptyRows(emptyRowCount);
        this.changeDetectorRef.markForCheck();
    }

    private produceEmptyRows(emptyRowCount: number): void {
        const oldEmptyRowCount: number = this.emptyRowViewRefs.length;

        if (emptyRowCount !== oldEmptyRowCount) {
            const countDiff: number = Math.abs(emptyRowCount - oldEmptyRowCount);

            for (let iEmptyRow = 0; iEmptyRow < countDiff; iEmptyRow++) {
                if (emptyRowCount > oldEmptyRowCount) {
                    this.createRow();
                } else {
                    this.removeRow();
                }
            }
        }
    }

    private createRow(): void {
        const viewRef: EmbeddedViewRef<EmptyRowTemplateContext> = this.viewContainerRef
            .createEmbeddedView(this.templateRef, this.emptyRowTemplateContext);

        this.emptyRowViewRefs.push(viewRef);
    }

    private removeRow(): void {
        const viewRef: EmbeddedViewRef<EmptyRowTemplateContext> = this.emptyRowViewRefs.pop();

        if (viewRef) {
            const viewRefIndex: number = this.viewContainerRef.indexOf(viewRef);

            this.viewContainerRef.remove(viewRefIndex);
        }
    }

    private listenToAvailableRowCount(): void {
        this.availableRowCount$
            .pipe(takeUntil(this.destroy$))
            .subscribe(availableRowCount => {
                this.minRowCount = availableRowCount;
                this.update();
            });
    }

}
